/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const COMPANY_BEGIN = 'COMPANY_BEGIN';
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS';
export const COMPANY_FAILURE = 'COMPANY_FAILURE';
export const COMPANY_CLEAR = 'COMPANY_CLEAR';

export const COMPANY_FILTER_BEGIN = 'COMPANY_FILTER_BEGIN';
export const COMPANY_FILTER_SUCCESS = 'COMPANY_FILTER_SUCCESS';
export const COMPANY_FILTER_FAILURE = 'COMPANY_FILTER_FAILURE';
export const COMPANY_FILTER_CLEAR = 'COMPANY_FILTER_CLEAR';

export function fetchCompany(params = {}) {
	return async dispatch => {
        dispatch(companyBegin());
        await ApiService.getClient(params)
			.then(
            result => {
                dispatch(companySuccess(result));
				},
				error => {
                    dispatch(companyError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}

export function fetchCompanyFilter() {
    return async dispatch => {
        dispatch(companyFilterBegin());
        await ApiService.getClientFilter()
            .then(
                result => {
                    dispatch(companyFilterAdd(result));
                },
                error => {
                    dispatch(companyFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

//Company
export const companyBegin = () => ({
    type: COMPANY_BEGIN,
});

export const companySuccess = data => ({
    type: COMPANY_SUCCESS,
	payload: { data }
})

export const companyError = () => ({
    type: COMPANY_FAILURE,
})

export const companyClear = () =>({
    type: COMPANY_CLEAR,
})

//Company Filters
export const companyFilterBegin = () => ({
    type: COMPANY_FILTER_BEGIN,
});
export const companyFilterAdd = filterData => ({
    type: COMPANY_FILTER_SUCCESS,
    payload: { filterData }
})
export const companyFilterError = filterError => ({
    type: COMPANY_FILTER_FAILURE,
    payload: { filterError }
})

export const companyFilterClear = () => ({
    type: COMPANY_FILTER_CLEAR,
})
